import { useMemo } from 'react';
import { paths } from 'src/routes/paths';
import SvgColor from 'src/components/svg-color';
import Iconify from 'src/components/iconify';
import { useAuthContext } from 'src/auth/hooks';

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = { dashboard: icon('ic_dashboard') };

const TELE_CLINIC_ID = process.env.REACT_APP_TELE_CLINIC_ID;

export function useNavData() {
  const { user } = useAuthContext();
  const userClinicId = user?.clinic_id;

  const data = useMemo(() => {
    const items = [
      { subheader: 'Overview', items: [{ title: 'Dashboard', path: paths.clinic_dashboard.root, icon: ICONS.dashboard }] },
      { subheader: 'Settings', items: [{ title: 'Business Profile', path: paths.clinic_dashboard.business_profile, icon: ICONS.dashboard }] },
      { subheader: 'Doctors', items: [{ title: 'Manage Doctors', path: paths.clinic_dashboard.doctors, icon: ICONS.dashboard }] },
      { subheader: 'Enquires', items: [{ title: 'Manage Enquires', path: paths.clinic_dashboard.enquires, icon: ICONS.dashboard }] },
      {
        subheader: 'Packages',
        items: [{ title: 'Manage Packages', path: paths.clinic_dashboard.packages, icon: ICONS.dashboard }],
      },
    ];

    if (userClinicId === TELE_CLINIC_ID) {
      items.push(
        {
          subheader: 'Tele Packages',
          items: [{ title: 'Manage Tele Packages', path: paths.clinic_dashboard.telepackages, icon: ICONS.dashboard }],
        },
        {
          subheader: 'Therapies',
          items: [{ title: 'Manage Therapies', path: paths.clinic_dashboard.telehealth, icon: ICONS.dashboard }],
        },
        {
          subheader: 'Products',
          items: [{ title: 'Manage Products', path: paths.clinic_dashboard.products, icon: ICONS.dashboard }],
        }
      );
    }

    return items;
  }, [userClinicId]);

  return data;
}

export function useBottomNavData() {
  const { user } = useAuthContext();
  const userClinicId = user?.clinic_id;
  console.log(userClinicId, TELE_CLINIC_ID);
  const data = useMemo(() => {
    const items = [
      { title: 'Home', path: paths.clinic_dashboard.root, icon: <Iconify icon="tabler:home" /> },
      { title: 'Bookings', path: paths.clinic_dashboard.root, icon: <Iconify icon="tabler:calendar-filled" /> },
      { title: 'Packages', path: paths.clinic_dashboard.packages, icon: <Iconify icon="tabler:brand-youtube" /> },
      { title: 'Profile', path: paths.clinic_dashboard.business_profile, icon: <Iconify icon="tabler:user" /> },
    ];

    if (userClinicId === TELE_CLINIC_ID) {
      items.push(
        { title: 'Tele Packages', path: paths.clinic_dashboard.telepackages, icon: <Iconify icon="tabler:package" /> },
        { title: 'Therapies', path: paths.clinic_dashboard.telehealth, icon: <Iconify icon="tabler:device-mobile" /> },
        { title: 'Products', path: paths.clinic_dashboard.products, icon: <Iconify icon="tabler:shopping-cart" /> }
      );
    }

    return items;
  }, [userClinicId]);

  return data;
}
